import { Folder } from '@/api/generatedApi';
import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import EditIcon from '@mui/icons-material/EditOutlined';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { Download as DownloadIcon } from '@mui/icons-material';
import { Divider, ListItemIcon, ListItemText } from '@mui/material';

export const FolderActionsMenuContent = ({
  folder,
  onClose,
  onRenameClick,
  onMoveClick,
  onDownloadClick,
  downloadDisabled,
  sx,
}: {
  folder: Folder;
  onClose: () => void;
  onRenameClick: (folder: Folder) => void;
  onMoveClick: (folder: Folder) => void;
  onDownloadClick?: (folder: Folder) => void;
  downloadDisabled?: boolean;
  sx?: object;
}) => {
  const { permissions } = useGetCurrentUser();
  const canManage = permissions.canCreateFolders;

  const handleRenameClick = () => {
    onRenameClick(folder);
    onClose();
  };

  const handleMoveClick = () => {
    onMoveClick(folder);
    onClose();
  };

  const handleDownloadClick = () => {
    onDownloadClick?.(folder);
    onClose();
  };

  if (!canManage && !onDownloadClick) {
    return;
  }

  return (
    <StyledList sx={sx}>
      <Divider />
      {onDownloadClick && (
        <StyledListItem
          onClick={downloadDisabled ? undefined : handleDownloadClick}
          sx={downloadDisabled ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
        >
          <ListItemIcon>
            <DownloadIcon sx={{ fontSize: '18px' }} />
          </ListItemIcon>
          <ListItemText>Download Folder</ListItemText>
        </StyledListItem>
      )}
      {canManage && (
        <>
          <StyledListItem onClick={handleRenameClick}>
            <ListItemIcon>
              <EditIcon sx={{ fontSize: '18px' }} />
            </ListItemIcon>
            <ListItemText>Rename Folder</ListItemText>
          </StyledListItem>
          <StyledListItem onClick={handleMoveClick}>
            <ListItemIcon>
              <DriveFileMoveIcon sx={{ fontSize: '18px' }} />
            </ListItemIcon>
            <ListItemText>Move Folder</ListItemText>
          </StyledListItem>
        </>
      )}
    </StyledList>
  );
};
